import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, unref as _unref, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "mt-6 grid grid-cols-2 gap-2 sm:grid-cols-4"
}
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { class: "mt-6 grid grid-cols-2 gap-2 sm:grid-cols-4" }
const _hoisted_4 = { class: "border border-gray-300 rounded-lg shadow-sm overflow-hidden bg-white px-4 py-5 sm:p-6" }
const _hoisted_5 = { class: "truncate text-sm font-medium text-gray-500" }
const _hoisted_6 = { class: "mt-1 text-3xl font-semibold tracking-tight text-gray-900" }
const _hoisted_7 = { class: "border border-gray-300 rounded-lg shadow-sm overflow-hidden bg-white px-4 py-5 sm:p-6" }
const _hoisted_8 = { class: "truncate text-sm font-medium text-gray-500" }
const _hoisted_9 = { class: "mt-1 text-3xl font-semibold tracking-tight text-gray-900" }
const _hoisted_10 = { class: "border border-gray-300 rounded-lg shadow-sm overflow-hidden bg-white px-4 py-5 sm:p-6" }
const _hoisted_11 = { class: "truncate text-sm font-medium text-gray-500" }
const _hoisted_12 = { class: "mt-1 text-3xl font-semibold tracking-tight text-gray-900" }
const _hoisted_13 = { class: "border border-gray-300 rounded-lg shadow-sm overflow-hidden bg-white px-4 py-5 sm:p-6" }
const _hoisted_14 = { class: "truncate text-sm font-medium text-gray-500" }
const _hoisted_15 = { class: "mt-1 text-3xl font-semibold tracking-tight text-gray-900" }

import usePluginStore from '@/store/plugin/plugin';
import { ref, onMounted } from 'vue';
import InstagramLiveMetadataMetrics from '@/models/plugin/instagramLiveMetadataMetrics';
import { useI18n } from 'vue-i18n';


export default /*@__PURE__*/_defineComponent({
  __name: 'PluginMetadatasMetrics',
  setup(__props) {

const { t } = useI18n();
const {
  pluginGetLiveMetadatasMetrics,
} = usePluginStore();

/*
  Data
*/
const isLoading = ref(true);
const metrics = ref({} as InstagramLiveMetadataMetrics);

/*
  Hooks
*/
onMounted(() => {
  pluginGetLiveMetadatasMetrics({}).then((res) => {
    [metrics.value] = res.data;
  }).catch((error) => {
    console.error('pluginGetLiveMetadatasMetrics', error);
  }).finally(() => {
    isLoading.value = false;
  });
});

return (_ctx: any,_cache: any) => {
  return (isLoading.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(4, (i) => {
          return _createElementVNode("div", {
            key: i,
            class: "border border-gray-300 rounded-lg shadow-sm overflow-hidden bg-white px-4 py-5 sm:p-6 animate-pulse"
          }, _cache[0] || (_cache[0] = [
            _createElementVNode("dt", { class: "truncate text-sm font-medium text-gray-300" }, " ... ", -1),
            _createElementVNode("dd", { class: "mt-1 h-8 bg-gray-200 rounded w-3/4" }, null, -1)
          ]))
        }), 64))
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_2, [
        _createElementVNode("dl", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("dt", _hoisted_5, _toDisplayString(_unref(t)('plugins.manager.metrics.total-plugins')), 1),
            _createElementVNode("dd", _hoisted_6, _toDisplayString(metrics.value?.formattedTotalPlugins() || '-'), 1)
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("dt", _hoisted_8, _toDisplayString(_unref(t)('plugins.manager.metrics.total-medias')), 1),
            _createElementVNode("dd", _hoisted_9, _toDisplayString(metrics.value?.formattedTotalMedias() || '-'), 1)
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("dt", _hoisted_11, _toDisplayString(_unref(t)('plugins.manager.metrics.total-messages')), 1),
            _createElementVNode("dd", _hoisted_12, _toDisplayString(metrics.value?.formattedTotalComments() || '-'), 1)
          ]),
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("dt", _hoisted_14, _toDisplayString(_unref(t)('plugins.manager.metrics.total-users')), 1),
            _createElementVNode("dd", _hoisted_15, _toDisplayString(metrics.value?.formattedTotalUsers() || '-'), 1)
          ])
        ])
      ]))
}
}

})